import axios from "axios";

/**
 * Zwei-Faktor-Anmeldung (backend#9).
 *
 * Zwei Faelle nach einem richtigen Passwort:
 *
 *   schritt "code"        2FA ist aktiv. Das Backend hat KEIN Sitzungstoken
 *                         ausgegeben, sondern ein Zwischen-Token (5 min), das
 *                         nur POST login/2fa oeffnet. Erst mit dem Code (oder
 *                         einem Wiederherstellungscode) gibt es die Sitzung.
 *   schritt "einrichten"  Die Organisation verlangt 2FA, der Benutzer hat sie
 *                         noch nicht. Die Sitzung oeffnet bis zur Einrichtung
 *                         nur die /2fa-Routen - die Plattform waere damit
 *                         nicht benutzbar. Deshalb wird hier eingerichtet,
 *                         bevor es weitergeht.
 *
 * Danach weiter wie ohne 2FA: Einmal-Code holen und zur Plattform (login#2).
 */

/**
 * Fehlerantwort als { status, code, meldung } fuer die Anzeige.
 *
 * Die Meldungen der /2fa-Routen sind deutsch und fuer Anwender geschrieben
 * (sie kommen mit Code); alles andere - etwa die englische Meldung der
 * Anmeldebremse je Adresse - ersetzen wir.
 */
export function fehlerAus(e, standard) {
  const antwort = (e && e.response) || {};
  const daten = antwort.data || {};
  if (antwort.status === 429) {
    return {
      status: 429,
      code: "GEBREMST",
      meldung: "Zu viele Fehlversuche. Bitte warte einige Minuten und versuche es dann erneut.",
    };
  }
  return {
    status: antwort.status || 0,
    code: daten.code || "FEHLER",
    meldung:
      (daten.code && daten.message) ||
      standard ||
      "Das hat nicht geklappt. Bitte versuche es erneut.",
  };
}

function mitToken() {
  return { headers: { authorization: localStorage.getItem("token") } };
}

const state = {
  //null | "code" | "einrichten"
  zweiFaktorSchritt: null,
  zwischenToken: null,
};

const getters = {
  zweiFaktorSchritt: (s) => s.zweiFaktorSchritt,
};

const mutations = {
  SET_ZWEI_FAKTOR(s, wert) {
    s.zweiFaktorSchritt = (wert && wert.schritt) || null;
    s.zwischenToken = (wert && wert.zwischenToken) || null;
  },
};

const actions = {
  /**
   * Zweiter Anmeldeschritt. Liefert { ok: true, uebrig } oder
   * { ok: false, code, meldung }. uebrig = verbleibende
   * Wiederherstellungscodes, wenn einer verwendet wurde, sonst null.
   */
  zweiFaktorAnmelden(context, { code, wiederherstellungscode }) {
    const body = { zwischenToken: context.state.zwischenToken };
    if (wiederherstellungscode) {
      body.wiederherstellungscode = String(wiederherstellungscode).trim();
    } else {
      body.code = String(code || "").replace(/\s/g, "");
    }

    return axios
      .post("login/2fa", body)
      .then((r) => {
        localStorage.setItem("token", r.data.token);
        context.commit("SET_LOGIN_INFO", r.data);
        const uebrig =
          typeof r.data.wiederherstellungscodesUebrig === "number"
            ? r.data.wiederherstellungscodesUebrig
            : null;
        return { ok: true, uebrig };
      })
      .catch((e) => ({ ok: false, ...fehlerAus(e) }));
  },

  /** Einrichtung beginnen: { geheimnis, otpauthUri, qrCode, konto } oder { fehler }. */
  zweiFaktorEinrichten() {
    return axios
      .post("2fa/setup", {}, mitToken())
      .then((r) => r.data)
      .catch((e) => ({ fehler: fehlerAus(e) }));
  },

  /** Einrichtung mit dem ersten Code bestaetigen: { ok, codes } oder { ok: false, meldung }. */
  zweiFaktorBestaetigen(context, code) {
    return axios
      .post("2fa/verify", { code: String(code || "").replace(/\s/g, "") }, mitToken())
      .then((r) => ({ ok: true, codes: r.data.wiederherstellungscodes || [] }))
      .catch((e) => ({ ok: false, ...fehlerAus(e) }));
  },

  /** Zurueck zur Passworteingabe. */
  zweiFaktorAbbrechen(context) {
    context.commit("SET_ZWEI_FAKTOR", null);
    localStorage.removeItem("token");
  },
};

export default { state, getters, mutations, actions };
